import React, { useRef, useState } from 'react'
import { Dialog, DialogContent, TextField, Button, IconButton, CircularProgress } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { Toast } from 'components/shared/Toaster'
import strings from 'strings'
import { completeTask } from 'actions/collaborativeTasks'

const CompleteTaskModal = ({ open, onClose, task, onDone }) => {
    const t = strings.CT
    const [notes, setNotes] = useState('')
    const [submitting, setSubmitting] = useState(false)
    const inFlight = useRef(false)

    const handleClose = () => {
        setNotes('')
        setSubmitting(false)
        inFlight.current = false
        onClose()
    }

    const handleSubmit = async () => {
        if (inFlight.current) return
        inFlight.current = true
        setSubmitting(true)
        try {
            const res = await completeTask(task.id, { notes: notes.trim() || null })()
            Toast({ type: 'success', message: t.COMPLETED_OK })
            onDone && onDone(res?.response || res)
            handleClose()
        } catch (e) {
            Toast({ type: 'error', message: t.COMPLETED_ERR })
        } finally {
            setSubmitting(false)
            inFlight.current = false
        }
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth classes={{ paper: 'ct-modal-paper' }}>
            <DialogContent>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div className="ct-modal-title">{t.MODAL_COMPLETE_TITLE}</div>
                    <IconButton onClick={handleClose} size="small"><CloseIcon /></IconButton>
                </div>

                <label className="ct-field-label">{t.FIELD_NOTES}</label>
                <TextField
                    variant="standard"
                    fullWidth
                    multiline
                    minRows={3}
                    placeholder={t.FIELD_NOTES_PLACEHOLDER}
                    value={notes}
                    onChange={e => setNotes(e.target.value)}
                    inputProps={{ maxLength: 1000 }}
                />

                <div className="ct-modal-footer">
                    <span />
                    <div style={{ display: 'flex', gap: 10 }}>
                        <Button onClick={handleClose} disabled={submitting}>{t.ACTION_CANCEL}</Button>
                        <Button
                            variant="contained"
                            style={{ background: 'var(--status-approved)', color: '#fff', textTransform: 'none', borderRadius: 10, fontWeight: 600 }}
                            onClick={handleSubmit}
                            disabled={submitting}
                            startIcon={submitting ? <CircularProgress size={14} style={{ color: '#fff' }} /> : null}
                        >
                            {t.ACTION_COMPLETE}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default CompleteTaskModal
